module.exports = "/images/clap-black.svg?689ebd5a45cec2892915030c9609ea64";